import {createGlobalStyle} from "styled-components";

export default createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Open Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    }

    :root {
        line-height: 1.5;
    }

    a {
        font-weight: 500;
        color: rgb(35, 88, 162);
        text-decoration: inherit;
    }

    a:hover {
        text-decoration: underline;
    }
`
